// packages/app/src/components/admin/models/CountrySwitcher.tsx
// AGC: Per-country selector for the recommendation model config. Brasil renders the
// AGC: existing UI; new countries (Argentina) render their own editor. Extensible.
import React from 'react'

export type ModelCountry = 'BR' | 'AR'

interface CountrySwitcherProps {
  value: ModelCountry
  onChange: (c: ModelCountry) => void
}

// AGC: Country names are proper nouns, shown verbatim (no i18n needed).
const TABS: Array<{ code: ModelCountry; label: string }> = [
  { code: 'BR', label: '🇧🇷 Brasil' },
  { code: 'AR', label: '🇦🇷 Argentina' },
]

export const CountrySwitcher: React.FC<CountrySwitcherProps> = ({ value, onChange }) => (
  <div className="flex gap-2 mb-4 border-b border-slate-200 dark:border-slate-700">
    {TABS.map((tab) => (
      <button
        key={tab.code}
        onClick={() => onChange(tab.code)}
        className={`px-4 py-2 text-sm font-medium -mb-px border-b-2 transition-colors ${
          value === tab.code
            ? 'border-emerald-600 text-emerald-700 dark:text-emerald-400'
            : 'border-transparent text-slate-500 hover:text-slate-700'
        }`}
      >
        {tab.label}
      </button>
    ))}
  </div>
)
